"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowCarbonGoalOptions = void 0;
exports.lowCarbonGoalOptions = [
    // Food
    { label: 'Buy local produce', value: '5ce0086d6944062c7f3610d4' },
    { label: 'Eat in season', value: '5cfa46d98a3ac29f658ed066' },
    { label: 'Eating less meat', value: '5ce00872bb5c8ed45b8bc1a0' },
    { label: 'Eat a vegetarian diet', value: '5cfa46843b5ec8b6f070e69a' },
    { label: 'Eat vegan diet', value: '5ce00867076524abf22a5789' },
    { label: 'Waste almost no edible food', value: '5cfa49617c4ec49542fbf6db' },
    { label: 'Compost your food waste', value: '5cfa49759dd77546a6c40a34' },
    { label: 'Only use reusable coffee cups', value: '5cfa4a0350f1fd976bdf98bf' },
    // Transport
    { label: 'Cycle to work', value: '5ce00849914321a657161822' },
    { label: 'Public transport to work', value: '5ce008617c9376a9b55c611c' },
    { label: 'Drive a hybrid vehicle', value: '5ce0087d25b647a28193d274' },
    {
        label: 'Drive a plug-in hybrid vehicle',
        value: '5cfa475d15e4683375586645',
    },
    { label: 'Drive an electric vehicle', value: '5cfa4b6e854602a5407dbe87' },
    {
        label: "'Staying grounded' (taking no flights)",
        value: '5cfa48dbbd51d175364c17b5',
    },
    {
        label: 'Limit plane travel to once a year',
        value: '5cfa48eacc03a6656bb24a73',
    },
    // Home energy
    { label: 'Changing light bulbs to LED', value: '5ce00877d638be1d8398f4d4' },
    {
        label: 'Switch to green energy provider',
        value: '5ce0085a4797c41e77094e73',
    },
    {
        label: 'Wash clothes at 30 degrees or lower',
        value: '5cfa45e8f68f2ca2c2ae991a',
    },
    {
        label: 'Washing clothes only when dirty',
        value: '5cfa4612b3159a873dd9a9e8',
    },
    { label: 'Line dry clothes', value: '5cfa466a2a7dfb7889cb56f6' },
    {
        label: 'Replace inefficient bulbs with LED',
        value: '5cfa480cf0f17134adbc6733',
    },
    // Consumer
    {
        label: 'Think before you throw anything into landfill',
        value: '5cfa465ae09fd1b1e9741536',
    },
    { label: 'Buy less (live more frugally)', value: '5cfa46288b7d1f29bdd28726' },
    { label: 'Refuse single use items', value: '5cfa48295ecc48d2022ce27d' },
    // Clothing
    { label: 'Stop supporting fast fashion', value: '5cfa44307eb6574646ee105f' },
    { label: 'Buy more second hand items', value: '5cfa444aa419c86ba550d060' },
    // Industry
    { label: 'Switch to a green bank/ethical banking', value: '6298af998a861a20744e9a47' },
    /*
      { label: 'Buy meat from a butcher', value: 'x', },
      { label: 'Using water more carefully', value: 'x', },
      { label: 'Compost your food waste', value: 'x', },
      { label: 'Plant a garden/window box', value: 'x', },
      { label: 'Cut down on plastics at home', value: 'x', },
      { label: 'Choose stay-cations', value: 'x', },
      { label: 'Recycle (everything)', value: 'x', },
      { label: 'Spend less than £200 per month on eating out', value: 'x', },
       */
];
//# sourceMappingURL=data:application/json;base64,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